import { Component, forwardRef, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-search-field',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './search-field.component.html',
    styleUrl: './search-field.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SearchFieldComponent),
            multi: true
        }
    ]
})
export class SearchFieldComponent implements ControlValueAccessor {
  @Input() showMatchCount: boolean = false;
  @Input() matchCount: number | null = null;
  @Input() placeholder: string = '';
  value = '';
  disabled = false;
  onChange = (value: string) => { };
  onTouched = () => { };

  writeValue(value: string): void {
    this.value = value || '';
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  handleInput(event: Event): void {
    const val = (event.target as HTMLInputElement).value;
    this.value = val;
    this.onChange(val);
  }
}
